module.exports = "/assets/data/05122e544a23d5e4bec7b77027be4831-GU5.data.json";